import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { MyCookieService } from './my-cookie.service';
import { tokenNotExpired } from 'angular2-jwt';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DialogLogin } from '../components/utilita/dialogs/dialog-login/dialog-login.component';
import { Observer } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class TokenExpiredService {
  constructor(private router: Router,
    private dialog: MatDialog,
    @Inject(MyCookieService) private myCookieService: MyCookieService) { }

  /**
   * Verifica se il token è abilitato e se è ancora valido,
   * se no si apre la dialog di login
   *
   * @returns {Observable<boolean>}
   * @memberof TokenExpiredService
   */
  ifTokenNotExpired(): Observable<boolean> {
    if (this.myCookieService.token) {
      if (!tokenNotExpired(environment.tokenName)) {
        let dialogRef = this.dialog.open(DialogLogin);
        return dialogRef.afterClosed().map(
          () => {
            // login effettuato
            return Observable.create((observer: Observer<boolean>) => {
              observer.next(true);
              observer.complete();
            });
          },
          () => {
            // login falito
            this.router.navigate(['/login']);
            return Observable.create((observer: Observer<boolean>) => {
              observer.next(false);
              observer.complete();
            });
          }
        );
      } else { return Observable.create((observer: Observer<boolean>) => {
        // token valido
        observer.next(true);
        observer.complete();
      }); }
    } else {
      return Observable.create((observer: Observer<boolean>) => {
        // token non abilitato
        this.router.navigate(['/login']);
        observer.next(false);
        observer.complete();
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/token-expired.service.ts